<div class="form-row m-0">
	<div class="form-row position-relative w-100">
		<mat-form-field appearance="outline" class="w-100">
			<input
				type="text"
				[placeholder]="placeholder"
				matInput
				[(ngModel)]="label"
				[formControl]="popControl"
				[matAutocomplete]="pops"
				(input)="clearAll($event)"
			/>
			<mat-autocomplete #pops="matAutocomplete" (optionSelected)="emitPop($event.option.value)">
				<cdk-virtual-scroll-viewport
					itemSize="48"
					class="autocomplete-virtual-scroll-viewport"
					cdkFixedSizeVirtualScroll
					minBufferPx="200"
					maxBufferPx="400"
					[style]="{ height: listHeight + 'px' }"
				>
					<mat-option
						*cdkVirtualFor="let option of popsOptions | async"
						cdkVirtualForTrackBy="trackByName"
						[value]="option"
						class="autocomplete-virtual-scroll-item"
					>
						{{ option.nome }}
					</mat-option>
				</cdk-virtual-scroll-viewport>
			</mat-autocomplete>
		</mat-form-field>
	</div>
</div>
